export function isMatchedIntroAndRecurringPricePeriod(
  introPrice: number,
  totalRecurringPrice: number,
  introductionBillingPeriod: string,
  recurringBillingPeriod: string,
  introductionBillingFrequency?: number,
  recurringBillingFrequency?: number,
  introductionBillingUnit?: string,
  recurringBillingUnit?: string,
): boolean {
  const isMatchPrice = introPrice === totalRecurringPrice;
  const isMatchPeriod = () => {
    if (introductionBillingPeriod === 'custom' && recurringBillingPeriod === 'custom') {
      return (
        introductionBillingFrequency === recurringBillingFrequency &&
        introductionBillingUnit === recurringBillingUnit
      );
    }

    return introductionBillingPeriod === recurringBillingPeriod;
  };

  return isMatchPrice && isMatchPeriod();
}
